import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "beat", "cta", "previewName"]
  static values = {
    personSignedId: String,
    treeId: Number,
    invitationToken: String,
    familyName: String,
    contributeUrl: String
  }

  connect() {
    this._beatTimer = null
    this._autoSubmitPending()
  }

  disconnect() {
    if (this._beatTimer) {
      clearTimeout(this._beatTimer)
      this._beatTimer = null
    }
  }

  openField(event) {
    event.preventDefault()
    const signedId = event.currentTarget.dataset.parentSignedId
    if (signedId) this.personSignedIdValue = signedId

    if (this.hasInputTarget) {
      this.inputTarget.classList.remove("hidden")
      this.inputTarget.querySelector("input")?.focus()
    }
  }

  submitName(event) {
    event.preventDefault()
    const input = this.inputTarget.querySelector("input")
    const name = input?.value?.trim()
    if (!name) return

    this.showPreview(name)
  }

  showPreview(name) {
    if (this.hasPreviewNameTarget) {
      this.previewNameTarget.textContent = name
    }
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("hidden", "opacity-0")
      this.previewTarget.classList.add("transition-opacity", "duration-500", "opacity-100")
    }

    if (this.hasInputTarget) {
      this.inputTarget.classList.add("hidden")
    }

    this.showBeat(name)
  }

  showBeat(name) {
    if (this.hasBeatTarget) {
      const message = this.beatTarget.dataset.messageTemplate || ""
      this.beatTarget.querySelector("[data-beat-text]").textContent = message
      this.beatTarget.classList.remove("hidden", "opacity-0")
      this.beatTarget.classList.add("transition-opacity", "duration-500", "opacity-100")
    }

    this._beatTimer = setTimeout(() => {
      this.storeContribution(name)
      this.showCta()
    }, 2000)
  }

  storeContribution(name) {
    const contribution = {
      person_signed_id: this.personSignedIdValue,
      name: name,
      tree_id: this.treeIdValue,
      invitation_token: this.invitationTokenValue
    }
    try {
      sessionStorage.setItem("bk_contribution", JSON.stringify(contribution))
    } catch (e) {
      // sessionStorage may be unavailable in private browsing
    }
  }

  showCta() {
    if (this.hasBeatTarget) {
      this.beatTarget.classList.add("hidden")
    }
    if (this.hasCtaTarget) {
      this.ctaTarget.classList.remove("hidden", "opacity-0")
      this.ctaTarget.classList.add("transition-opacity", "duration-500", "opacity-100")
    }
  }

  // D2: Auto-submit stored contribution after OAuth return
  _autoSubmitPending() {
    if (!this.hasContributeUrlValue || !this.contributeUrlValue) return

    try {
      const raw = sessionStorage.getItem("bk_contribution")
      if (!raw) return
      const contribution = JSON.parse(raw)
      if (!contribution.name || contribution.invitation_token !== this.invitationTokenValue) return

      sessionStorage.removeItem("bk_contribution")
      this._postContribution(contribution)
    } catch (e) {
      // sessionStorage parse error — ignore
    }
  }

  _postContribution(contribution) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.contributeUrlValue
    form.style.display = "none"

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrf) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "authenticity_token"
      input.value = csrf
      form.appendChild(input)
    }

    const nameInput = document.createElement("input")
    nameInput.type = "hidden"
    nameInput.name = "contribution[name]"
    nameInput.value = contribution.name
    form.appendChild(nameInput)

    if (contribution.person_signed_id) {
      const parentInput = document.createElement("input")
      parentInput.type = "hidden"
      parentInput.name = "contribution[parent_signed_id]"
      parentInput.value = contribution.person_signed_id
      form.appendChild(parentInput)
    }

    document.body.appendChild(form)
    form.submit()
  }
}
